export default "__VITE_ASSET__wMeECsyw__"